var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.736,
    height: 54.323,
    viewBox: "0 0 52.736 54.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #00404f;\r\n        stroke-linecap: round;\r\n        stroke-width: 4px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frio",
    "data-name": "Icon Frio",
    transform: "translate(0.509 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59",
    transform: "translate(17.722)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_6",
    "data-name": "Linha 6",
    className: "cls-1",
    y2: 50.322,
    transform: "translate(8.147)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_7",
    "data-name": "Linha 7",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "translate(0 3.834)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_10",
    "data-name": "Linha 10",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "translate(16.274 46.488) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_8",
    "data-name": "Linha 8",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 16.274, 3.821)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_9",
    "data-name": "Linha 9",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 0, 46.502)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60",
    transform: "translate(43.581 5.534) rotate(60)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_6-2",
    "data-name": "Linha 6",
    className: "cls-1",
    y2: 50.322,
    transform: "translate(8.147 0)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_7-2",
    "data-name": "Linha 7",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "translate(0 3.834)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_10-2",
    "data-name": "Linha 10",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "translate(16.274 46.488) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_8-2",
    "data-name": "Linha 8",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 16.274, 3.821)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_9-2",
    "data-name": "Linha 9",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 0, 46.502)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61",
    transform: "translate(51.718 30.695) rotate(120)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_6-3",
    "data-name": "Linha 6",
    className: "cls-1",
    y2: 50.322,
    transform: "translate(8.147 0)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_7-3",
    "data-name": "Linha 7",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "translate(0 3.834)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_10-3",
    "data-name": "Linha 10",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "translate(16.274 46.488) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_8-3",
    "data-name": "Linha 8",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 16.274, 3.821)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_9-3",
    "data-name": "Linha 9",
    className: "cls-1",
    x2: 8.147,
    y2: 6.23,
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 0, 46.502)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrio);
export default __webpack_public_path__ + "static/media/Frio.6cd9fe92fe768f41eaf8a3bf61b893d9.svg";
export { ForwardRef as ReactComponent };